'use strict';/* global define */define('modules/integrations/states/admin_integrations/index',['require','exports','module'],function(require,exports,module){'use strict';/**
   * Define the data restriction based on the roles
   *
   * @param {Function} roleCheck - Helper function to verify particular role.
   * @param {Object}   ROLES     - Definition of the possible roles.
   *
   * @return {Object}            - Resolves promise for roleCheck.
   */// @ngInject
restricted.$inject = ["roleCheck", "ROLES"];
function restricted(roleCheck,ROLES){return roleCheck.promise(ROLES.admin);}return{abstract:true,data:{restricted:restricted}};});
